class BlogVideo extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    setTimeout(
      function () {
        this.init();
      }.bind(this),
      100
    );
  }
  init() {
    this.playButton = this.querySelector(".play-button");
    this.muteButton = this.querySelector(".mute-button");
    this.video = this.querySelector("video");
    this.playButton.addEventListener("click", this.togglePlay.bind(this));
    this.muteButton.addEventListener("click", this.toggleMute.bind(this));
  }
  togglePlay() {
    console.log("togglePlay");
    console.log(this.video);
    if (this.video.paused) {
      this.video.play();
      this.classList.add("playing");
    } else {
      this.video.pause();
      this.classList.remove("playing");
    }
  }
  toggleMute() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("muted");
    } else {
      this.video.muted = true;
      this.classList.add("muted");
    }
  }
}

customElements.define("blog-video", BlogVideo);
